import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const triggerPdfDownload = createAsyncThunk(
  'pdfDownloads/triggerPdfDownload',
  async ({ projectId, Apiurl }, { dispatch, rejectWithValue }) => {
    const token = localStorage.getItem('u_token');
    const newDownload = {
      id: projectId,
      name: `Project #${projectId}`,
      status: 'loading',
    };

    dispatch(addActiveDownload(newDownload));

    let preFix = Apiurl?.includes('log') ? 'Catalogue' : 'Quotation';

    try {
      const response = await fetch(`${Apiurl}/${projectId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (!response.ok) throw new Error('Download failed');

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${preFix}_${projectId}.pdf`);
      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);

      dispatch(updateDownloadStatus({ id: projectId, status: 'success' }));
    } catch (error) {
      console.error('PDF Download Error:', error);
      dispatch(updateDownloadStatus({ id: projectId, status: 'error' }));
      return rejectWithValue(error.message);
    } finally {
      setTimeout(() => {
        dispatch(removeActiveDownload(projectId));
      }, 3000);
    }
  }
);

const initialState = {
  activeDownloads: [],
};

const pdfDownloadSlice = createSlice({
  name: 'pdfDownloads',
  initialState,
  reducers: {
    addActiveDownload: (state, action) => {
      state.activeDownloads.push(action.payload);
    },
    updateDownloadStatus: (state, action) => {
      const { id, status } = action.payload;
      const download = state.activeDownloads.find((d) => d.id === id);
      if (download) {
        download.status = status;
      }
    },
    removeActiveDownload: (state, action) => {
      state.activeDownloads = state.activeDownloads.filter((d) => d.id !== action.payload);
    },
  },
});

export const { addActiveDownload, updateDownloadStatus, removeActiveDownload } = pdfDownloadSlice.actions;
export default pdfDownloadSlice.reducer;
